import { render } from "./ArchivedRelatedDocumentsSection.vue?vue&type=template&id=19f4292a&scoped=true&ts=true&lang=pug"
import script from "./ArchivedRelatedDocumentsSection.vue?vue&type=script&lang=ts"
export * from "./ArchivedRelatedDocumentsSection.vue?vue&type=script&lang=ts"

import "./ArchivedRelatedDocumentsSection.vue?vue&type=style&index=0&id=19f4292a&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f4292a"]])

export default __exports__